import api from './api';

const siteConfigService = {
  getConfig: async () => {
    const response = await api.get('/site-config');
    return response.data;
  },

  // Blank string clears a field (the app falls back to its built-in default)
  updateConfig: async (values) => {
    const response = await api.put('/site-config', values);
    return response.data;
  }
};

export default siteConfigService;
